import React, { useState } from 'react';
import { IonPage, IonContent, IonCard, IonCardContent, IonImg, IonText, IonList, IonItem, IonLabel } from '@ionic/react';
// Image imports
import vinod_jain from '../theme/images/commetiee/vinod_jain2.jpg';
import pramod_kapur from '../theme/images/commetiee/pramod_kapur.jpg';
import anil_sharma from '../theme/images/commetiee/anil_sharma.jpg';
import avneesh_matta from '../theme/images/commetiee/avneesh_matta.jpg';
import naveen_jain from '../theme/images/commetiee/naveen_jain.jpg';
import praveen_sharma from '../theme/images/commetiee/praveen_sharma.jpg';
import shiv_mittal from '../theme/images/commetiee/shiv_mittal.jpg';
import sunil_khemka from '../theme/images/commetiee/sunil_khemka.jpg';
import vijay_gupta from '../theme/images/commetiee/Business-Businessman-icon.png';
import vinod_rustogi from '../theme/images/commetiee/vinod_rustogi.jpg';
import rajiv_kholi from '../theme/images/commetiee/rajiv_kholi.jpg';
import deepak_bahl from '../theme/images/commetiee/Business-Businessman-icon.png';
import inderjeet from '../theme/images/commetiee/inderjeet.jpg';
import manmohan_khemka from '../theme/images/commetiee/manmohan_khemka.jpg';
import pramod_jain from '../theme/images/commetiee/pramod_jain.jpg';
import ajay_kumar from '../theme/images/commetiee/ajay_kumar.jpg';
import rajesh_rastogi from '../theme/images/commetiee/Business-Businessman-icon.png';
import dc_garg from '../theme/images/commetiee/dc_garg.jpg';
import binu_nanda from '../theme/images/commetiee/binu_nanda.jpg';
import manoj_pahwa from '../theme/images/commetiee/manoj_pahwa.jpg';
import vaibhav_jain from '../theme/images/commetiee/vaibhav_jain.jpg';
import dc_garg_dt from '../theme/images/commetiee/CA-DC-Garg.jpg';
import aastha_jain from '../theme/images/commetiee/CA-Aastha-Jain.jpg';
import mohit_gupta from '../theme/images/commetiee/CA-Mohit-Gupta.jpg';
import vaibhav_jain_dt from '../theme/images/commetiee/CA-Vaibhav-Jain.jpg';
import baldev_raj from '../theme/images/commetiee/CA-Baldev-Raj.jpg';
import kc_gupta from '../theme/images/commetiee/CA-K-C-Gupta.jpg';
import raj_kumar_garg from '../theme/images/commetiee/CA-Raj-Kumar-Garg.jpg';
import rajat_jain from '../theme/images/commetiee/CA.-Rajat-Jain.jpg';
import anoop_dhanda from '../theme/images/commetiee/anoop_dhanda.jpg';
import sudhir_jain from '../theme/images/commetiee/sudhir_jain.jpg';
import ravi_sachdeva from '../theme/images/commetiee/ravi_sachdeva.jpg';
import mk_rustagi from '../theme/images/commetiee/Business-Businessman-icon.png';
import vimal_khanna from '../theme/images/commetiee/vimal_khanna.jpg';
import rajesh_mittal from '../theme/images/commetiee/rajesh_mittal.jpg';
import dc_mathur from '../theme/images/commetiee/Business-Businessman-icon.png';
import atul_chawla from '../theme/images/commetiee/atul_chawla.jpg';
import angad_pal_singh from '../theme/images/commetiee/angad_pal_singh.jpg';
import rahul_srivastava from '../theme/images/commetiee/rahul_srivastava.jpg';
import kanchan_mittal from '../theme/images/commetiee/kanchan_mittal.jpg';
import aanchal_aggarwal from '../theme/images/commetiee/Business-Businessman-icon.png';
import sakshi_jain from '../theme/images/commetiee/Business-Businessman-icon.png';
import atishai_jain from '../theme/images/commetiee/atishai_jain.jpg';
import praveen_thakur from '../theme/images/commetiee/praveen_thakur.jpg';
import avash_ghimire from '../theme/images/commetiee/Business-Businessman-icon.png';
import deepesh_bansal from '../theme/images/commetiee/Business-Businessman-icon.png';
import dishant_kapur from '../theme/images/commetiee/Business-Businessman-icon.png';

const CommitteeMember = ({ title, name, contact, firm, image }) => (
    <div className="member-card-wrapper">
        <IonCard className="member-card">
            <IonImg src={image} alt={name} className="member-image" />
            <IonCardContent>
                <IonText color="primary">
                    <h2 className="member-name">{name}</h2>
                </IonText>
                <IonText>
                    <p className="member-contact">{contact}</p>
                </IonText>
                {firm && (
                    <IonText>
                        <p className="member-firm">{firm}</p>
                    </IonText>
                )}
            </IonCardContent>
        </IonCard>
    </div>
);

const CommitteeSection = ({ title, members }) => (
    <div className="committee-section">
        <IonText color="dark">
            <h2 className="committee-title">{title}</h2>
        </IonText>
        <div className="custom-grid">
            {members.map((member, index) => (
                <CommitteeMember key={index} {...member} />
            ))}
        </div>
    </div>
);

export default function CommitteesPage({renderHeaderPage}) {
    const [activeTab, setActiveTab] = useState('ACCOUNTING & AUDITING COMMITTEE');

    const committees = {
        'ACCOUNTING & AUDITING COMMITTEE': [
            {
                title: 'Convenor',
                members: [
                    { name: 'CA Rajiv Kohli', contact: '9873430075', image: rajiv_kholi },
                    { name: 'CA Deepak Bahl', contact: '9810084888', image: deepak_bahl },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'CA Inderjeet Walecha', contact: '9873414632', image: inderjeet },
                    { name: 'CA Man Mohan Khemka', contact: '9810064427', image: manmohan_khemka },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Pramod Jain', contact: '9811073867', image: pramod_jain },
                ],
            },
        ],
        'GST COMMITTEE': [
            {
                title: 'Chairman',
                members: [
                    { name: 'CA Ajay Kumar Matta', contact: '9811277782', image: ajay_kumar },
                    { name: 'CA Rajesh Rastogi', contact: '9810296909', image: rajesh_rastogi },
                ],
            },
            {
                title: 'Vice Chairman',
                members: [
                    { name: 'CA Ajay Kumar Matta', contact: '9811277782', image: ajay_kumar },
                    { name: 'CA Rajesh Rastogi', contact: '9810296909', image: rajesh_rastogi },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'CA DC Garg', contact: '9811039211', image: dc_garg },
                    { name: 'CA Binu Nanda', contact: '9810508866', image: binu_nanda },
                    { name: 'CA Deepak Bahl', contact: '9810084888', image: deepak_bahl },
                    { name: 'CA Manoj Pahwa', contact: '9811066276', image: manoj_pahwa },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Rajiv Kohli', contact: '9873430075', image: rajiv_kholi },
                ],
            },
            {
                title: 'Members',
                members: [
                    { name: 'CA Vaibhav Jain', contact: '9711310004', image: vaibhav_jain },
                ],
            },
        ],
        'DIRECT TAXES COMMITTEE': [
            {
                title: 'Chairman',
                members: [
                    { name: 'CA D C Garg', contact: '+91 9811039211', image: dc_garg_dt },
                ],
            },
            {
                title: 'Co-Chairman',
                members: [
                    { name: 'CA Aastha Jain', contact: '+91 9999903556', image: aastha_jain },
                ],
            },
            {
                title: 'Vice Chairman',
                members: [
                    { name: 'CA Baldev Raj', contact: '+91 9312235173', image: baldev_raj },
                    { name: 'CA Mohit Gupta', contact: '+91 9818043245', image: mohit_gupta },
                ],
            },
            {
                title: 'Coordinator',
                members: [
                    { name: 'CA Vaibhav Jain', contact: '+91 9711310004', image: vaibhav_jain_dt },
                ],
            },
        ],
        'FINANCE PROFESSIONALS GROUP': [
            {
                title: 'Chairman',
                members: [
                    { name: 'CA K C Gupta', contact: '+91 9899102761', image: kc_gupta },
                ],
            },
            {
                title: 'Vice Chairman',
                members: [
                    { name: 'CA Raj Kumar Garg', contact: '+91 9810725520', image: raj_kumar_garg },
                    { name: 'CA Rajat Jain', contact: '+91 9891114179', image: rajat_jain },
                ],
            },
            {
                title: 'Coordinator',
                members: [
                    { name: 'CA Vaibhav Jain', contact: '+91 9711310004', image: vaibhav_jain_dt },
                ],
            },
        ],
        'MEMBERS IN INDUSTRY COMMITTEE': [
            {
                title: 'Convenor',
                members: [
                    { name: 'CA Anoop Dhanda', contact: '9810153639', image: anoop_dhanda },
                    { name: 'CA Sudhir Jain', contact: '9818427021', image: sudhir_jain },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'CA Ravi Sachdeva', contact: '9811106762', image: ravi_sachdeva },
                    { name: 'CA M.K. Rustagi', contact: '9999380808', image: mk_rustagi },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Praveen Sharma', contact: '9810011802', image: praveen_sharma },
                ],
            },
            {
                title: 'Member',
                members: [
                    { name: 'CA Vimal Khanna', contact: '9811544044', image: vimal_khanna },
                    { name: 'CA Rajesh Mittal', contact: '9999380808', image: rajesh_mittal },
                    { name: 'CA D. C. Mathur', contact: '9810016348', image: dc_mathur },
                    { name: 'CA Naveen Jain', contact: '9871699802', image: naveen_jain },
                ],
            },
        ],
        'YOUNG MEMBERS COMMITTEE': [
            {
                title: 'Convenor',
                members: [
                    { name: 'CA Atul Chawla', contact: '9818161122', image: atul_chawla },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'CA Vaibhav Jain', contact: '9711310004', image: vaibhav_jain },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Praveen Sharma', contact: '9810011802', image: praveen_sharma },
                    { name: 'CA Pramod Kapur', contact: '9810730568', image: pramod_kapur },
                ],
            },
            {
                title: 'Member',
                members: [
                    { name: 'CA Angad Pal Singh', contact: '9911515363', image: angad_pal_singh },
                    { name: 'CA Rahul Srivastava', contact: '9818627551', image: rahul_srivastava },
                ],
            },
        ],
        'WOMEN MEMBERS COMMITTEE': [
            {
                title: 'Convenor',
                members: [
                    { name: 'CA Binu Nanda', contact: '9810508866', image: binu_nanda },
                    { name: 'CA Kanchan Mittal', contact: 'xxxxxxxxxx', image: kanchan_mittal },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'CA Aastha Jain', contact: '9999903556', image: aastha_jain },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Rajiv Kohli', contact: '9873430075', image: rajiv_kholi },
                ],
            },
        ],
        'STUDENTS COMMITTEE': [
            {
                title: 'Convenor',
                members: [
                    { name: 'Aanchal Aggarwal', contact: '8588800869', image: aanchal_aggarwal },
                    { name: 'Sakshi Jain', contact: '9990894749', image: sakshi_jain },
                ],
            },
            {
                title: 'Co-Convenor',
                members: [
                    { name: 'Atishai Jain', contact: '9760045007', image: atishai_jain },
                    { name: 'Praveen Thakur', contact: '9953765149', image: praveen_thakur },
                ],
            },
            {
                title: 'Advisor',
                members: [
                    { name: 'CA Vaibhav Jain', contact: '+91 9711310004', image: vaibhav_jain_dt },
                ],
            },
            {
                title: 'Members',
                members: [
                    { name: 'Avash Ghimire', contact: '9958356457', image: avash_ghimire },
                    { name: 'Deepesh Bansal', contact: '9654141456', image: deepesh_bansal },
                    { name: 'Dishant Kapur', contact: '9540016160', image: dishant_kapur },
                ],
            },
        ],
    };

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="common-content page-content">
                <div className="committee-container">
                    <IonText color="dark">
                        <h1 className="m-0 p-heading text-left">Our Leadership</h1>
                    </IonText>
                    <div className="custom-grid">
                        <CommitteeMember
                            title="Founder"
                            name="CA Vinod Jain"
                            contact="9811040004"
                            firm="Vinod Kumar & Associates, CA"
                            image={vinod_jain}
                        />
                        <CommitteeMember
                            title="President"
                            name="CA Pramod Kapur"
                            contact="9810730568"
                            firm="J.L. Garg & Co, CA"
                            image={pramod_kapur}
                        />
                        <CommitteeMember
                            title="Vice President"
                            name="CA Anil Sharma"
                            contact="9811320203"
                            firm="A. Sharma & Co, CA"
                            image={anil_sharma}
                        />
                    </div>
                    <div className="custom-grid">
                        <CommitteeMember
                            name="CA Avineesh Matta"
                            contact="9811052264"
                            image={avneesh_matta}
                        />
                        <CommitteeMember
                            name="CA Naveen Jain"
                            contact="9871699802"
                            image={naveen_jain}
                        />
                        <CommitteeMember
                            name="CA Praveen Sharma"
                            contact="9810011802"
                            image={praveen_sharma}
                        />
                        <CommitteeMember
                            name="CA Shiv Mittal"
                            contact="9810048576"
                            image={shiv_mittal}
                        />
                    </div>
                    <div className="custom-grid">
                        <CommitteeMember
                            name="CA Sunil Khemka"
                            contact="9313510085"
                            image={sunil_khemka}
                        />
                        <CommitteeMember
                            name="CA Vijay Gupta"
                            contact="9810757167"
                            image={vijay_gupta}
                        />
                        <CommitteeMember
                            name="CA Vinod Rustagi"
                            contact="9999971101"
                            image={vinod_rustogi}
                        />
                    </div>

                    <IonText color="dark">
                        <h1 className="section-title mt-8">Committee Members</h1>
                    </IonText>
                    <div className="tab-list">
                        {Object.keys(committees).map((committee) => (
                            <div
                                key={committee}
                                onClick={() => setActiveTab(committee)}
                                className={`tab-item ${activeTab === committee ? 'active' : ''}`}
                            >
                                <IonLabel>{committee}</IonLabel>
                            </div>
                        ))}
                    </div>

                    {Object.entries(committees).map(([committeeName, sections]) => (
                        <div
                            key={committeeName}
                            className={`tab-content ${activeTab === committeeName ? 'active' : ''}`}
                        >
                            {sections.map((section, index) => (
                                <CommitteeSection key={index} title={section.title} members={section.members} />
                            ))}
                        </div>
                    ))}
                </div>
            </IonContent>
        </IonPage>
    );
}